var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"text-capitalize",attrs:{"plain":"","rounded":""},on:{"click":_vm.download}},[_c('v-icon',{staticClass:"me-2"},[_vm._v(_vm._s(_vm.icons.mdiDownload))]),_vm._v(" İndir ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }